import { z } from "zod/v4";

import { OrganizationSummaryDtoSchema } from "../../../dtos/organization-summaries";

export const GetAllOrgSummariesByAgencyIdRequestPathParamSchema = z.object({
  agencyId: z.uuid(),
});

export type GetAllOrgSummariesByAgencyIdRequestPathParamType = z.infer<
  typeof GetAllOrgSummariesByAgencyIdRequestPathParamSchema
>;

export const GetAllOrgSummariesByAgencyIdResponseBodySchema = z.object({
  orgs: OrganizationSummaryDtoSchema.array(),
});

export type GetAllOrgSummariesByAgencyIdResponseBodyType = z.infer<
  typeof GetAllOrgSummariesByAgencyIdResponseBodySchema
>;
